import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { toast } from 'react-toastify';

import {
  get_roleconfig,
  update_roleconfig,
  create_roleconfig,
} from '../api/api';

const RoleConfigModal = forwardRef(({ roleConfigs, roleConfigData, isOpen, isUpdate=false, onClose }, ref) => {
  const [id, setId] = useState('');
  const [scoutasticName, setScoutasticName] = useState('');
  const [pdfName, setPdfName] = useState('');
  const [description, setDescription] = useState('');
  const [error, setError] = useState('');


  const ROLE_OPTIONS = ["GK","RCB","LCB","RB","CM","LB","RCM","LCM","RW","CF","AM","LW","SS"];


  useImperativeHandle(ref, () => ({
    reset: () => {
      setId('');
      setPdfName('');
      setError('');
    },
    setup: (data) => {
      console.log(data);
      setId(data?.id || '');
      setPdfName(data?.pdf_name || '');
      setScoutasticName(data?.scoutastic_name || '');
      setError('');
    }
  }));

  const handleUpdate = async () => {
    if (!pdfName.trim()) {
      setError("Il campo 'PDF Role' non può essere vuoto.");
      return;
    }

    try {
      if(isUpdate){
        await update_roleconfig(id, { scoutastic_name: scoutasticName, pdf_name: pdfName });
        toast.success("Aggiornamento completato");
        onClose();
      }
      else{
        await create_roleconfig({ scoutastic_name: scoutasticName , pdf_name: pdfName });
        toast.success("Aggiornamento completato");
        onClose();
      }

    } catch (err) {
      console.error(err);
      setError("Errore durante l'aggiornamento. Riprova.");
    }
  };

  if (!isOpen) return null;




  return (
    <div className="modal-overlay">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-container">
        <div className="modal-header">
          <h2 className="modal-title-document">{isUpdate ? "Modifica associazione" : "Aggiungi associazione"}</h2>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-content">
          <div className="modal-body">


        <div style={{marginBottom:"15px"}}>


              <div>
                <div style={{marginBottom:"20px"}}>Utilizzare i campi seguenti per definire l'associazione:</div>

                <label className="field-label">Label del ruolo ricevuta da Scoutastic</label>

                <input
                  type="text"
                  value={scoutasticName}
                  onChange={(e) => { setScoutasticName(e.target.value); ; console.log(scoutasticName) }}
                  className="field-input"
                  placeholder="Inserisci Ruolo"
                />
             </div>




        </div>




            <label className="field-label">Sigla del ruolo da mostrare nel PDF</label>
            <select className="field-input" onChange={(e) => { setPdfName(e.target.value); console.log(pdfName)}}>
              <option value="">Scegli una sigla ruolo</option>
                {

                (ROLE_OPTIONS).map((r)=>{
                  if(pdfName==r){
                     return <option value={r} selected>{r}</option>
                  }
                  else{
                     return <option value={r}>{r}</option>
                  }
                })}

            </select>

            {error && <div className="modal-error">{error}</div>}
          </div>
        </div>

        <div className="modal-footer">
          <button className="footer-btn btn-secondary" onClick={onClose}>Annulla</button>
          <button className="footer-btn btn-primary" onClick={handleUpdate}>Salva</button>
        </div>
      </div>
    </div>
  );
});

export default RoleConfigModal;
